import React from 'react';
import { Helmet } from 'react-helmet';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/main.scss';
import SideBarButton from '../components/SideBarButton/SideBarButton';
import TopHeader from '../components/TopHeader/TopHeader';
import ProjectInfo from '../components/ProjectInfo';
import Pdf from '../files/TSBK03_projektrapport.pdf';

const repo = 'https://github.com/iriskotsinas/DomeDagen';

const item = {
  title: 'Voronoi Fracturing',
  description:
    'In fall 2021, I took the course TSBK03 Advanced Game Programming at Linköping University. It consisted of a series of four labs as well as a project. The course covered topics within computer graphics implemented in C++ and OpenGL.',
  description2:
    "The project was made by my project partner and I, and it explores how the destruction of 2D objects, such as walls and glass planes, can be simulated realistically. This is done with 2D Voronoi diagrams using Fortune's algorithm in C++ and OpenGL. The generated fragments are extruded into 3D and simulated with Bullet Physics as rigid bodies. Different patterns are implemented for the distribution of points. The resulting simulation provides a semi-realistic destruction of objects in real-time. My partner and I did every step of the way together in order for us both to understand every part.",
  image: '3.png',
  image2: '4.png',
  slug: '/voronoi-fracturing',
  report: Pdf,
  simulation: '',
  sourcecode: repo,
};

export default function VoronoiFracturing() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Iris Kotsinas</title>
        <html lang="en" />
        <meta name="description" content="Iris Portfolio" />
      </Helmet>
      <TopHeader isStartPage={false} />
      <ProjectInfo item={item} isSpecial={false} />
      <SideBarButton showBelow={70} />
    </>
  );
}
